import promoImpression, {
  type PromoImpression,
  isPromoImpressionName,
} from 'analytics/promo-impressions';
import { usePodObserver } from './use-pod-observer';

type UsePromoImpression = {
  componentId?: string;
  analytics?: {
    promoName?: PromoImpression['name'];
    vendor?: string;
    impressionUrls?: string[];
  };
  position?: string;
  products?: {
    id: string;
  }[];
};

export function usePromoImpression({
  componentId,
  analytics,
  position,
  products,
}: UsePromoImpression) {
  return usePodObserver(() => {
    if (analytics && isPromoImpressionName(analytics.promoName)) {
      promoImpression({
        id: componentId,
        name: analytics.promoName,
        position,
        products,
        urls: analytics.impressionUrls,
        vendor: analytics.vendor,
      });
    }
  });
}
